var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdlePause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:3.5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#FFFFFF",
    d: "M7,20c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2s2,0.9,2,2v12C9,19.1,8.1,20,7,20z M19,18V6c0-1.1-0.9-2-2-2 s-2,0.9-2,2v12c0,1.1,0.9,2,2,2S19,19.1,19,18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdlePause);
export default __webpack_public_path__ + "static/media/idle-pause.de3534081cfd491b842b8e4aae76a204.svg";
export { ForwardRef as ReactComponent };